import { render, staticRenderFns } from "./DefectsMonitoring.vue?vue&type=template&id=845c3340&"
import script from "./DefectsMonitoring.vue?vue&type=script&lang=js&"
export * from "./DefectsMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports